// frontend/src/components/CookieBanner.tsx

import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ANALYTICS_CONSENT_COOKIE } from '../utils/consent';

interface CookieBannerProps {
  onAccept: () => void;
  onDecline: () => void;
}

const CookieBanner: React.FC<CookieBannerProps> = ({ onAccept, onDecline }) => {
  const { t } = useTranslation();

  return (
    <CookieConsent
      location="bottom"
      buttonText={t('forms.consent.cookie_button')}
      cookieName={ANALYTICS_CONSENT_COOKIE}
      style={{
        background: 'rgba(17, 24, 39, 0.98)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        fontSize: '14px',
        alignItems: 'center',
        // Solid bar — backdrop-filter blur competes with LCP/INP on first paint.
        boxShadow: '0 -4px 20px rgba(0,0,0,0.5)',
        zIndex: 99998,
      }}
      buttonStyle={{
        backgroundColor: '#16a34a',
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
        borderRadius: '12px',
        padding: '10px 24px',
        boxShadow: '0 0 10px rgba(22, 163, 74, 0.3)',
      }}
      declineButtonText={t('forms.consent.cookie_decline_button')}
      declineButtonStyle={{
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        color: '#d1d5db',
        fontSize: '14px',
        fontWeight: 'normal',
        borderRadius: '12px',
        padding: '10px 16px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
      }}
      expires={150}
      enableDeclineButton
      onAccept={onAccept}
      onDecline={onDecline}
    >
      <span className="text-gray-300">
        {t(
          'forms.consent.cookie_text',
          'We use essential cookies to run the product. Optional analytics and ads measurement cookies (Google Analytics, Google Ads, Application Insights) load only if you accept.'
        )}{' '}
        <Link to="/cookies" className="text-primary-light underline underline-offset-2 hover:text-white">
          {t('nav.cookies', 'Cookies')}
        </Link>
        {' · '}
        <Link to="/privacy" className="text-primary-light underline underline-offset-2 hover:text-white">
          {t('nav.privacy', 'Privacy')}
        </Link>
      </span>
    </CookieConsent>
  );
};

export default CookieBanner;
